import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const CAPEX_ASSOCIATION_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('CAPEX_ASSOCIATION');
export const CAPEX_ASSOCIATION_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	CAPEX_ASSOCIATION_CRUD_ACTION_CONSTANTS
);
